// import "../public-dynamic/stylesheets/$shortcuts.css";
import "./static/css/_dev.css";
import "./static/css/app.css";
import "./static/css/form.css";

import { Toaster } from "solid-sonner";
import { QRouter } from ":setup/qrouter";
import { Modal } from "./components/popup";
import { ConfirmDialog } from "./components/popup";
import { Meta } from "./contexts/helmet";

// routes bases
import { Landing, Auth, Participant, Evaluator, Filterer, Judge, Auditor, Support } from "./routes";
export function EntryClient() {
  return (
    <Meta>
      <Toaster richColors closeButton class="!z-200" />
      <Modal />
      <ConfirmDialog />
      <QRouter>
        <Landing />
        <Auth />
        <Participant />
        <Evaluator />
        <Filterer />
        <Judge />
        <Auditor />
        <Support />
      </QRouter>
    </Meta>
  );
}
